'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';


const categorieLabels: Record<string, string> = {
  laboratorio: 'Laboratorio',
  ufficio: 'Ufficio',
  medico: 'Medico',
  iot: 'IoT',
  server: 'Server',
  virtuale: 'Virtuale',
  rete: 'Rete',
};

const statusLabels: Record<string, string> = {
  online: 'Online',
  offline: 'Offline',
  latenza_alta: 'Latenza Alta',
  intermittente: 'Intermittente',
  manutenzione: 'Manutenzione',
};

interface DeviceFiltersProps {
  search: string;
  onSearch: (v: string) => void;
  categoriaFilter: string;
  onCategoriaFilter: (v: string) => void;
  statusFilter: string;
  onStatusFilter: (v: string) => void;
  repartoFilter: string;
  onRepartoFilter: (v: string) => void;
  reparti: string[];
}

export default function DeviceFilters({
  search, onSearch,
  categoriaFilter, onCategoriaFilter,
  statusFilter, onStatusFilter,
  repartoFilter, onRepartoFilter,
  reparti,
}: DeviceFiltersProps) {
  return (
    <div className="flex flex-wrap gap-3 items-center">
      <div className="relative flex-1 min-w-48">
        <Icon name="MagnifyingGlassIcon" size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-color" />
        <input
          type="text"
          value={search}
          onChange={e => onSearch(e.target.value)}
          placeholder="Cerca hostname, IP, MAC, reparto..."
          className="w-full bg-surface border border-border rounded-lg pl-9 pr-4 py-2.5 text-sm text-white placeholder:text-muted-color focus:outline-none focus:border-sky-500 transition-colors"
        />
      </div>

      <select
        value={categoriaFilter}
        onChange={e => onCategoriaFilter(e.target.value)}
        className="bg-surface border border-border rounded-lg px-3 py-2.5 text-sm text-secondary-color focus:outline-none focus:border-sky-500 transition-colors"
      >
        <option value="all">Tutte le categorie</option>
        {Object.entries(categorieLabels).map(([k, v]) => (
          <option key={k} value={k}>{v}</option>
        ))}
      </select>

      <select
        value={statusFilter}
        onChange={e => onStatusFilter(e.target.value)}
        className="bg-surface border border-border rounded-lg px-3 py-2.5 text-sm text-secondary-color focus:outline-none focus:border-sky-500 transition-colors"
      >
        <option value="all">Tutti gli stati</option>
        {Object.entries(statusLabels).map(([k, v]) => (
          <option key={k} value={k}>{v}</option>
        ))}
      </select>

      <select
        value={repartoFilter}
        onChange={e => onRepartoFilter(e.target.value)}
        className="bg-surface border border-border rounded-lg px-3 py-2.5 text-sm text-secondary-color focus:outline-none focus:border-sky-500 transition-colors"
      >
        <option value="all">Tutti i reparti</option>
        {reparti.map(r => (
          <option key={r} value={r}>{r}</option>
        ))}
      </select>
    </div>
  );
}